module.exports = __webpack_public_path__ + "img/bookmarks.b12b055d.svg";